
TS.ns('WL');

WL.leasingFolderCreditDecisionModel = new Class({
    Extends: WL.leasingFolderBaseModel,

    initialize: function (config) {
        var me = this;

        me.parent(config);
    },

    _addApprovals: function () {
        var me = this;

        me.performServerCommand({
            cmd: 'AddApprovals',
            submitModel: true,
            blockUI: false
        });
    },

    _editApprovals: function () {
        var me = this;

        var approvalsList = me.getDomainProperty('dgDocumentApproval_Property');
        if (approvalsList.SelectedItem() === null)
            me.performServerCommand({
                cmd: 'EditApprovals',
                submitModel: true,
                extraData: { UID: null }, 
                blockUI: false
            });
        else {
            me.performServerCommand({
                cmd: 'EditApprovals',
                submitModel: true,
                extraData: { UID: approvalsList.SelectedItem().UID() },
                blockUI: false
            });
        }
    },

    _delApprovals: function () {
        var me = this;

        var approvalsList = me.getDomainProperty('dgDocumentApproval_Property');
        if (approvalsList.SelectedItem() === null)
            me.performServerCommand({
                cmd: 'DeleteApprovals',
                submitModel: true,
                extraData: { UID: null },
                blockUI: false
            });
        else {
            me.performServerCommand({
                cmd: 'DeleteApprovals',
                submitModel: true,
                extraData: { UID: approvalsList.SelectedItem().UID() },
                blockUI: false
            });
        }
    },

    _viewApprovalHistory: function () {
        var me = this;

        me.performServerCommand({
            cmd: 'ViewApprovalHistory',
            submitModel: true,
            blockUI: false
        });
    } 

});

